import LoyaltyRewardList from './loyaltyRewardList.js';
import LoyaltyRewardEdit from './loyaltyRewardEdit.js';
import LoyaltyRewardCreate from './loyaltyRewardCreate.js';


export default {
    list: LoyaltyRewardList,
    edit: LoyaltyRewardEdit,
    create: LoyaltyRewardCreate
}